function isLoopbackOrchestratorUrl(base: string): boolean {
  try {
    const withProto = base.includes('://') ? base : `http://${base}`;
    const u = new URL(withProto);
    return u.hostname === 'localhost' || u.hostname === '127.0.0.1' || u.hostname === '[::1]';
  } catch {
    return /localhost|127\.0\.0\.1/.test(base);
  }
}

/**
 * Raíz del interaction-orchestrator (sin /api/v1 final).
 * Tolera env con barra final o con sufijo /api/v1 duplicado.
 *
 * En **desarrollo**, las peticiones usan el mismo origen que Vite (p. ej. túnel ngrok) y
 * `vite.config.ts` hace proxy de `/api/v1` → tu orquestador local, salvo que definas una URL
 * **pública** explícita (p. ej. segundo ngrok). Si el env apunta a localhost, también se usa el
 * proxy para que la Mini App en el móvil no llame al localhost del teléfono ("Load failed").
 */
export function getOrchestratorRootUrl(): string {
  const explicit = (
    import.meta.env.VITE_INTERACTION_ORCHESTRATOR_URL ||
    import.meta.env.VITE_ORCHESTRATOR_URL ||
    ''
  )
    .toString()
    .trim();
  if (!explicit) {
    if (import.meta.env.DEV) {
      return '';
    }
    return 'http://localhost:3020';
  }
  let base = explicit.replace(/\/+$/, '');
  if (base.endsWith('/api/v1')) {
    base = base.slice(0, -'/api/v1'.length).replace(/\/+$/, '');
  }
  if (import.meta.env.DEV && isLoopbackOrchestratorUrl(base)) {
    return '';
  }
  // Evita base HTTP remota que causa preflight con redirect (302) y bloqueo del navegador.
  if (
    base.startsWith('http://') &&
    !base.includes('localhost') &&
    !base.includes('127.0.0.1')
  ) {
    base = `https://${base.slice('http://'.length)}`;
  }
  return base;
}
